import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router';

import scrollToComponent from 'react-scroll-to-component';

import {diamondImgUrl, diamondTitle, diamondPrice, diamondCartDesc} from '../../../../../utils/formatting';

import * as cartActionCreators from '../../../../../actions/cart';
import * as productActionCreators from '../../../../../actions/product';
let allActionCreators = Object.assign({}, cartActionCreators, productActionCreators);

import {FloatingHeaderContainer} from '../blocks/FloatingHeader';
import RhinoLoading from '../../../common/RhinoLoading';

import {DiamondGridContainer} from './grids/DiamondGrid';
import {CompareProductsContainer} from '../blocks/CompareProducts';


class DiamondResults extends React.Component {

  static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

  constructor(props) {

    super(props);
    this.state = {
      upperTabSelected: 'best',
      nextStepsOpen: false,
      addingToCart: false,

      assembledOpen: true,

      openedClass: ' opened',
    };
  }

  componentDidMount() {

  }

  componentWillUnmount() {

  }

  internalNav(page) {
    this.context.router.push('/' + page);
  }

  externalNav(page) {
    window.location.href = '/' + page;
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

  getProductMainImage(product) {
    if(product.image_count > 0) {
      return 'https://dd2-temp-img.s3.amazonaws.com/' + product.sku + '/0.jpg';
    }
  }

  // getDiamondDrawing(diamond) {
  //   switch(diamond.shape) {
  //     case 'Round':
  //       return 'https://ddw2.diamondsdirect.com/img/gallery/engagement/diamonds/round.svg';
  //     case 'Pear':
  //       return 'https://ddw2.diamondsdirect.com/img/gallery/engagement/diamonds/pear.svg';
  //     case 'Heart':
  //       return 'https://ddw2.diamondsdirect.com/img/gallery/engagement/diamonds/pear.svg';
  //     case 'Oval':
  //       return 'https://ddw2.diamondsdirect.com/img/gallery/engagement/diamonds/round.svg';
  //     case 'Cushion':
  //       return 'https://ddw2.diamondsdirect.com/img/gallery/engagement/diamonds/cushion.svg';
  //     case 'Emerald':
  //       return 'https://ddw2.diamondsdirect.com/img/gallery/engagement/diamonds/emerald_1.svg';
  //     case 'Radiant':
  //       return 'https://ddw2.diamondsdirect.com/img/gallery/engagement/diamonds/radiant.svg';
  //     case 'Marquise':
  //       return 'https://ddw2.diamondsdirect.com/img/gallery/engagement/diamonds/round.svg';
  //     case 'Asscher':
  //       return 'https://ddw2.diamondsdirect.com/img/gallery/engagement/diamonds/asscher.svg';
  //     case 'Princess':
  //       return 'https://ddw2.diamondsdirect.com/img/gallery/engagement/diamonds/princess.svg';
  //     default:
  //       return 'https://ddw2.diamondsdirect.com/img/gallery/engagement/diamonds/round.svg';      
  //   }
  // }

  scrollTop() {
    scrollToComponent(this.topSection, {
      offset: 0, 
      align: 'top', 
      duration: 1000, 
      ease: 'inOutCube',
    });
    this.setState({ upperTabSelected: 'best' });
  }

  scrollCompare() {
    scrollToComponent(this.topSection, {
      offset: 0, 
      align: 'top', 
      duration: 1000, 
      ease: 'inOutCube',
    });
    this.setState({ upperTabSelected: 'picks' });
  }

  getFavesLength() {
    return this.props.product.compareDiamonds.length.toString();
  }

  selectDiamond(diamond) {
    this.props.productSelectDiamond(diamond);
  }

  isDiamondSelected() {
    return this.props.product.selectedDiamond !== null;
  }

  selectUpperTab(tabVal) {
    this.setState({ upperTabSelected: tabVal });
  }

  toggleNextSteps() {
    this.setState({ nextStepsOpen: !this.state.nextStepsOpen });
  }

  addToCart() {

    let shapeString = this.props.product.selectedDiamond.shape;

    this.setState({ addingToCart: true });

    this.props.cartAddDiamond(this.props.product.selectedDiamond.stockNo, this.props.product.selectedDiamond.price, shapeString.toLowerCase().trim(), diamondCartDesc(this.props.product.selectedDiamond))
    .then((resp) => {
      console.log(resp);
      this.externalNav('checkout/cart');
    })
    .catch((errResp) => {
      this.setState({ addingToCart: false });
    });
  }

  addSetting() {
    this.props.setParentMode('mixed');
    // this.internalNav('gallery/engagement-rings');
  }

  scrollToResults() {
    if(!this.resultsSection) { return; }
    scrollToComponent(this.resultsSection, {
      offset: 0, 
      align: 'top', 
      duration: 1000, 
      ease: 'inOutCube',
    });
  }

  toggleAssembled() {
    this.setState({
      assembledOpen: !this.state.assembledOpen,
      openedClass: '',
    }, () => {
      if(this.state.assembledOpen) {
        setTimeout(() => {
          this.setState({ openedClass: ' opened' });
        }, 500);
      }
    });
  }

  render() {

    const RESULT_LIMIT = 24;

    let dCount = 0;

    return <div className='DiamondResults' ref={(div) => { this.topSection = div; }}>
      
      <FloatingHeaderContainer 
        scrollTop={::this.scrollTop}
        scrollCompare={::this.scrollCompare}
        getFavesLength={::this.getFavesLength} />

      <div className={this.state.assembledOpen ? `assembledWrapper open ${this.state.openedClass}` : 'assembledWrapper'}>
        <div className='assembledToggle' onClick={::this.toggleAssembled}>
          {this.state.assembledOpen ?
            <div className='assembledToggleIcon'>&mdash;</div> :
            <div className='assembledToggleIcon'>+</div>
          }
        </div>
        <div className={'assembledTabsWrapper desktopOnly'}>
          <div className={this.state.upperTabSelected == 'best' ? 'assembledTab selectedTab' : 'assembledTab'} onClick={() => this.selectUpperTab('best')}>Your Diamond</div>
          <div className={this.state.upperTabSelected == 'picks' ? 'assembledTab selectedTab' : 'assembledTab'} onClick={() => this.selectUpperTab('picks')}>Compare Diamonds ({this.getFavesLength()} of 4)</div>
        </div>
        <div className={'assembledTabsWrapper mobileOnly'}>
          <div className={this.state.upperTabSelected == 'best' ? 'assembledTab selectedTab' : 'assembledTab'} onClick={() => this.selectUpperTab('best')}>Your Diamond</div>
          <div className={this.state.upperTabSelected == 'picks' ? 'assembledTab selectedTab' : 'assembledTab'} onClick={() => this.selectUpperTab('picks')}>Compare</div>
        </div>
        {this.state.upperTabSelected == 'best' ?
          <div className='assembledPreview'>
            <div className='assembledVBR'></div>

            <div className={'assembledComponentWrapper fullWidth'}>
              {this.isDiamondSelected() ?
                <div className='diamondComponentWrapper'>
                  <div className='diamondComponentImageWrapper'>
                    <img src={this.props.product.selectedDiamond.image} />
                  </div>
                  <div className='diamondComponentInfoWrapper'>
                    <div className='diamondInfoTitleRow'>
                      <span className='diamondInfoTitle'>{diamondTitle(this.props.product.selectedDiamond)}</span>
                      <span className='removeLink' onClick={() => this.props.productSelectDiamond(null)}>remove</span>
                    </div>
                    <div className='diamondInfoCustomRow'>
                      <div className='diamondInfoPrice'>${this.props.product.selectedDiamond.price.toLocaleString()}</div>
                      <div className='priceNotice'>(diamond&nbsp;&nbsp;only)</div>
                    </div>
                    <div className='diamondInfoButtonRow'>
                      {this.state.addingToCart ?
                        <div className='nextStepsInCart'><div><i className="fas fa-spinner fa-pulse"></i>&nbsp;&nbsp;&nbsp;Adding to Cart</div></div> :
                        <div className='nextStepsWrapper'>
                          <div className='nextStepsElement' onClick={::this.toggleNextSteps}>
                            <div className='nextStepsHead'>
                              <div className='nextStepsLabel'>Next Steps</div>
                              <div className='nextStepsIcon'>
                                <img src='https://ddw2.diamondsdirect.com/img/productpage/down.svg' />
                              </div>
                            </div>
                            <div className={this.state.nextStepsOpen ? 'nextStepsBody open' : 'nextStepsBody'}>
                              <div className='nextStepsBodyWrapper'>
                                <div className='nextStepsItem' onClick={() => this.addToCart()}>Add to Cart</div>
                                <div className='nextStepsItem' onClick={() => this.internalNav('diamond/' + this.props.product.selectedDiamond.id)}>View Diamond</div>
                                <div className='nextStepsItem' onClick={() => this.addSetting()}>Add to Ring</div>
                                <div className='nextStepsItem' onClick={() => this.internalNav('contact-us')}>Request an Appointment</div>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                </div> :
                <div className='diamondMessageWrapper'>
                  <div className='diamondNullMessage'>Choose a diamond below to get started!</div>
                </div>
              }
            </div>
          </div> :
          <CompareProductsContainer productType={'diamond'} />
        }
          
      </div>

      <div className='resultsWrapper' ref={(div) => { this.resultsSection = div; }}>
        <div className='resultsTabWrapper'>
          <div className={'resultTab selectedTab'}>Diamond Results</div>
        </div>
        <div className='resultsBody' ref={(div) => { this.resultsBody = div; }}>
          <DiamondGridContainer 
            updateMethod={::this.props.updateMethod} 
            scrollUp={::this.scrollToResults} 
            showSplashPage={::this.props.showSplashPage}
            openFilters={this.props.openFilters} />
        </div>
      </div>
    </div>;
  }
}
export default DiamondResults;

function mapStateToProps(state) {
  return {
    product: state.product,
  };
}

export const DiamondResultsContainer = connect(
  mapStateToProps,
  allActionCreators
)(DiamondResults);


// WEBPACK FOOTER //
// ./src/components/views/gallery/blocks/results/DiamondResults.jsx